import UpdateDeliveryAddressRequestModelBase from '../_generated/modelBases/update-delivery-address-request-model-base';

export default class UpdateDeliveryAddressRequestModel extends UpdateDeliveryAddressRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
